import { useMemo } from 'react';

import { EVENT_STATUSES } from '@jebel/constants';

import { ChooseStatusChip, ChooseStatusChipOption } from 'shared/components/ui';

interface Props {
  status: string;
  options?: ChooseStatusChipOption[];
}

const EVENT_STATUS_COLORS = {
  [EVENT_STATUSES.active]: '#01B9A1',
  [EVENT_STATUSES.pendingApproval]: '#EF5C5C',
  [EVENT_STATUSES.inactive]: '#616DEE',
  [EVENT_STATUSES.expired]: '#FF782A',
};

const EVENT_STATUS_LABEL = {
  [EVENT_STATUSES.active]: 'Active',
  [EVENT_STATUSES.pendingApproval]: 'Pending Approval',
  [EVENT_STATUSES.inactive]: 'Inactive',
  [EVENT_STATUSES.expired]: 'Expired',
};

export function ChooseEventStatusChip(props: Props) {
  const color = useMemo(() => {
    return EVENT_STATUS_COLORS[props.status];
  }, [props.status]);

  const label = useMemo(() => {
    return EVENT_STATUS_LABEL[props.status];
  }, [props.status]);

  return <ChooseStatusChip label={label} color={color} options={props.options} />;
}
